module.exports = __webpack_public_path__ + "static/media/GitHub_Logo_White.064ace47.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/GitHub_Logo_White.png
// module id = 33
// module chunks = 0